/* Copyright (c) 2023 GRIP.S Medien GmbH & Co.KG */

import Typography from '@material-ui/core/Typography';
import React from 'react';

const FourOhFour = () => (
  <Typography variant='h4' gutterBottom>
    404 - not found
  </Typography>
);

export default FourOhFour;
